import { Button, Form, FormInstance, Input, InputNumber, message, Modal, Space } from "antd";
import FormItem from "antd/es/form/FormItem";
import React from "react";
import { useEffect, useState } from "react";
import Server from "../../../server/Server";
import URL from "../../../server/URL";

const Recharge = (props: any) => {
    const formRef = React.useRef<FormInstance>(null);
    const { ...rest } = props;
    const [balance, setBalance] = useState(0);
    const [account, setAccount] = useState<any>({});

    useEffect(() => {
        if (rest.isOpen) {
            loadAccount();
            loadMemberAccount();
        }
    }, [rest.isOpen])

    const loadAccount = () => {
        var params = {};
        Server.Post(URL.Account.GetAccount, params).then((response: any) => {
            if (response.isSuccess) {
                setAccount(response);
            }
        })
    }

    const loadMemberAccount = () => {
        var params = { memberID: rest.member?.memberID };
        Server.Post(URL.Member.GetMemberAccount, params).then((response: any) => {
            if (response.isSuccess) {
                setBalance(response.balance);
            }
        })
    }

    const handleOk = () => {
        formRef.current?.validateFields(['amount'])
            .then((values) => {
                if (values.amount <= 0) {
                    message.warn('充值金额必须大于0');
                    return;
                }
                var params = {
                    memberID: rest.member.memberID,
                    amount: values.amount
                };
                Server.Post(URL.Agent.RechargeAgent, params).then((response: any) => {
                    if (response.isSuccess) {
                        rest.setIsOpen(false);
                        message.success('充值成功')
                        rest.reload();
                    }
                });
            })
    }
    const handleCancel = () => {
        rest.setIsOpen(false);
    }
    return <Modal width={400} title="代理充值" open={rest.isOpen}
        onCancel={handleCancel}
        bodyStyle={{ padding: 0, margin: 8 }}
        maskClosable={false}
        footer={
            <Space>
                <Button size='middle' onClick={handleCancel}>关闭窗口</Button>
                <Button type='primary' onClick={handleOk} danger size='middle'>立即充值</Button>
            </Space>
        }>
        <Form ref={formRef} size='middle'>
            <FormItem label={'充值组织'}>
                <span style={{ width: '100%' }}>{account.organizationName}</span>
            </FormItem>
            <FormItem label={'组织余额'}>
                <span style={{ width: '100%' }}>{account.balance ?? 0}(元)</span>
            </FormItem>
            <FormItem label={'充值会员'}>
                <span style={{ width: '100%' }}>{rest.member?.account}</span>
            </FormItem>
            <FormItem label={'会员余额'}>
                <span style={{ width: '100%' }}>{balance}(元)</span>
            </FormItem>
            <FormItem label={'充值金额'} initialValue={0} name={'amount'} >
                <InputNumber max={account.balance ?? 0} style={{ width: '100%' }} min={1} addonAfter="(元)" status="error"
                    step="0.01" />
            </FormItem>
        </Form>
    </Modal>
}
export default Recharge;